import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBL2sD3b3heNN5z4YawVwM5qSVRgd0DvVU",
  authDomain: "oravainen-perhe.firebaseapp.com",
  projectId: "oravainen-perhe",
  storageBucket: "oravainen-perhe.firebasestorage.app",
  messagingSenderId: "435675190663",
  appId: "1:435675190663:web:3f2f94c3bcfef79b99ef22"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Firestore con caché offline persistente
// - Guarda automáticamente todos los datos que se cargan en IndexedDB
// - Si no hay internet, muestra los datos del caché local
// - persistentMultipleTabManager permite que funcione en varias pestañas a la vez
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});
